
import { useState, useEffect } from 'react'
import './index.less'
import React from 'react'
console.log(React)

export default function Selector(props) {
  const [ifon, setIfon] = useState({
    isOpen: false,
    activeId: props.activeId
  })

  useEffect(() => {
    const func = () => {
      setIfon({
        ...ifon,
        isOpen: false
      })
    }
    window.addEventListener('click', func)
    return () => {
      window.removeEventListener('click', func)
    }
  })

  return (<div className='selector'>
    <div className='selector_text' onClick={(e) => {
      e.stopPropagation()
      setIfon({
        ...ifon,
        isOpen: !ifon.isOpen
      })
    }}>
      <span className='text'>{props.options && props.options.filter((item) => {
        return item.id === ifon.activeId
      })[0].text}</span>
    </div>
    {ifon.isOpen && <div className='selector_box'>
      {props.options && props.options.map((item) => {
        return (<span onClick={(e) => {
          e.stopPropagation()

          if (disables(item.id, props.disables)) {
            return
          }
          setIfon({
            ...ifon,
            activeId: item.id,
            isOpen: false
          })
          props.change && props.change(item)
        }} className={`box_text ${ifon.activeId === item.id ? 'active' : ''} ${disables(item.id, props.disables) ? 'disable' : ''}`} key={item.id}>{item.text}</span>)
      })}
    </div>}

  </div>)
}

function disables(id, ids) {
  if (!ids) {
    return false
  }
  return ids.includes(id)
}

